import Commons from '../../../../Services/Common/Common';

/**
 * 그리드/API 필드: CO_CD, CO_NM, PL_TYPE (기존 화면과 동일).
 * Save/Delete API 본문은 PascalCase 키 + 암호화 문자열.
 */
export const COU_BASIC_Schema = {
  fields: {
    CO_CD: { initial: '', label: '회사', required: 'Y' },
    PL_TYPE: { initial: '', label: '구분', required: 'Y' },
  },
  mapper: {
    search1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(String(context.coCd ?? '').trim()) || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      CoCd: (row) => Commons.EncryptAES(row.CO_CD ?? row.coCd ?? '') || '',
      PlType: (row) =>
        Commons.EncryptAES(row.PL_TYPE ?? row.plType ?? '') || '',
    },
    delete1: {
      CoCd: (row) => Commons.EncryptAES(row.CO_CD ?? row.coCd ?? '') || '',
      PlType: (row) =>
        Commons.EncryptAES(row.PL_TYPE ?? row.plType ?? '') || '',
    },
  },
};
